import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import { useState } from 'react'
import { Modal, ModalBody, Button, Spinner } from 'reactstrap'

const ModalSellerConfirmPayment = ({
  isOpen,
  toggle,
  onConfirm,
  isLoading,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered data-testid="detail-transaction-modal-confirm">
      <ModalBody>
        <P size="medium" className="fw-semibold mb-1">
          Konfirmasi Pembayaran Pembeli
        </P>
        <p>
          Pastikan Anda sudah menerima pembayaran dari pembeli sebelum
          melanjutkan.
        </p>
        <div className="d-flex gap-2 justify-content-center mt-4">
          <CustomButton
            onClick={toggle}
            className="btn-cancel"
            outline
            block
            disabled={isLoading}
            testId="detail-transaction-modal-confirm-cancel"
          >
            Batal
          </CustomButton>
          <CustomButton
            color="primary"
            block
            onClick={onConfirm}
            disabled={isLoading}
            testId="detail-transaction-button-confirm-payment"
          >
            Lanjut
          </CustomButton>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalSellerConfirmPayment
